import { memo } from "react";
import Lottie from "react-lottie";

import StickyButton from "@/common/StickyButton";
import { useLocalization } from "@/hooks/useLocalization";
import i18n from "@/localization/i18next";
import { cortisolChartByLng } from "@/male/utils/cortisolChartByLng";
import { HandleNext } from "@/types/common";
import { useFlowManager } from "@/utils/providers/FlowProvider";

interface CortisolScreenProps {
    handleNext: HandleNext;
    isActive: boolean;
}
const CortisolScreen = ({ handleNext, isActive }: CortisolScreenProps) => {
    const { language } = useLocalization();
    const { isFlowType } = useFlowManager({});

    const title = isFlowType.calisthenics
        ? "Our calisthenics workout plan was created to ensure a balanced testosterone/cortisol ratio."
        : i18n.t("plan_to_ensure_balanced_cortisol");
    return (
        <div className="grid h-full gap-10 text-white">
            <div className="h-full">
                <div className="grid">
                    <div className="grid gap-4">
                        <div className="text-zing-32-40 font-semibold">
                            {i18n.t("level_of_cortisol")}
                        </div>
                    </div>
                </div>
                {isActive && (
                    <div className="w-[calc(100%+24px*2)] -translate-x-6">
                        <Lottie
                            options={{
                                animationData: cortisolChartByLng[language],
                                loop: false,
                            }}
                            isClickToPauseDisabled
                        />
                    </div>
                )}
                <div className="grid gap-4 pt-6">
                    <span className="text-zing-18-26 font-semibold">{title}</span>
                    <div className="grid gap-2">
                        <span className="text-zing-16-22">
                            {i18n.t("cortisol_increases_linearly")}
                        </span>
                        <span className="text-zing-16-22">
                            {i18n.t("pecific_threshold_of_exercise_intensity")}
                        </span>
                        <span className="text-zing-16-22">
                            {i18n.t("physical_stressors_result_cortisol")}
                        </span>
                        <span className="text-zing-16-22">
                            {i18n.t("overtraining_result_extreme_stressor")}
                        </span>
                    </div>
                </div>
            </div>
            <StickyButton
                onClick={() => handleNext()}
                className="items-end transition-opacity"
                isDisabled={false}
            >
                {i18n.t("got_it")}
            </StickyButton>
        </div>
    );
};

export default memo(CortisolScreen);
